import React from 'react'
import PropTypes from 'prop-types'
import { Marker, InfoWindow } from 'google-maps-react'

import { MapComponent } from '../../maps';

import image1 from '../../icons/1.png';
import dot from '../../icons/dot.png';

class PhoneMap extends React.Component {
  render () {
    const { locations } = this.props
    const mapStyle = { height: 'calc(100vh - 100px)' }

    return (
      <React.Fragment>
        {
          !!locations &&
          <MapComponent
            style={mapStyle}
            initialCenter={Object.values(locations).pop()} >
            {({ onMarkerClick, activeMarker, showingInfoWindow, selectedPlace, google }) => [
              (Object.keys(locations).map((key, index) => {
                  let image

                  if (index < 29) {
                    image = {
                      url: dot,
                      anchor: new google.maps.Point(8, 8),
                      scaledSize: new google.maps.Size(16, 16)
                    }
                  } else {
                    image = {
                      url: image1,
                      anchor: new google.maps.Point(16, 16),
                      scaledSize: new google.maps.Size(32, 32)
                    }
                  }

                  return (
                    <Marker
                      key={key}
                      title={key}
                      name={`Date: ${key}`}
                      icon={image}
                      onClick={onMarkerClick}
                      position={{lat: locations[key].latitude, lng: locations[key].longitude}}
                    />
                  )
                })
              ),
              <InfoWindow
                marker={activeMarker}
                visible={showingInfoWindow}>
                  <div>
                    <h4>{selectedPlace.name}</h4>
                    {
                      !!activeMarker && !!activeMarker.position &&
                      (
                        <p>
                          Latitude: {activeMarker.position.lat()}
                          <br/>
                          Longitude: {activeMarker.position.lng()}
                        </p>
                      )
                    }
                  </div>
              </InfoWindow>
            ]}
          </MapComponent>
        }
      </React.Fragment>
    )
  }

  static propTypes = {
    locations: PropTypes.arrayOf(PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    })),
    last: PropTypes.shape({
      latitude: PropTypes.string,
      longitude: PropTypes.string,
    })
  }
}

export default PhoneMap;



// WEBPACK FOOTER //
// ./src/components/Phone/PhoneMap.js